import View from './view';
export const PrivilegeDetailsParameter = View;
